import { ApolloError } from '@apollo/client';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PostMarkMessagesAsUnflagMutationFn } from 'generated/graphql';

interface markMessagesUnflagResponse {
  success?: boolean;
  error?: ApolloError | undefined;
  messageUids?: number[];
  mailboxId?: string;
}

interface markMessageUnflagArgs {
  payload: {
    mailboxId: string;
    messageUids: number[];
  };
  markMessagesUnflagHook: PostMarkMessagesAsUnflagMutationFn;
}

export const markMessagesUnflagThunk = createAsyncThunk(
  'markMessagesUnflag',
  async (arg: markMessageUnflagArgs): Promise<markMessagesUnflagResponse> => {
    try {
      const response = await arg.markMessagesUnflagHook({
        variables: {
          mailboxId: arg.payload.mailboxId,
          messageUids: arg.payload.messageUids,
        },
      });
      return {
        success: response?.data?.markMessagesUnimportant.success || false,
        messageUids: arg.payload.messageUids,
        mailboxId: arg.payload.mailboxId,
      };
    } catch (e) {
      return {
        error: e as ApolloError,
      };
    }
  }
);
